import { Lock } from "lucide-react"
import { DropdownMenuItem } from "@/components/ui/dropdown-menu"

/** Stands in for "Delete Record" on a local stock record that has sales or
    adjustments: those stay for the audit trail, so there's nothing to click —
    just the reason. */
export function KeptForAuditNote() {
  return (
    <DropdownMenuItem disabled data-kept-for-audit className="items-start gap-1.5 text-xs text-muted-foreground data-[disabled]:opacity-100">
      <Lock className="mt-0.5 h-3.5 w-3.5 shrink-0" />
      <span>Can't delete — has sales or adjustments (kept for audit)</span>
    </DropdownMenuItem>
  )
}
